import store from '@/store'

export default () => {
  if (typeof window !== 'undefined') {
    const getters = store.getters

    if (getters && getters.parentSize && getters.parentSize.width) {
      const parentWidth = getters.parentSize.width

      return parentWidth < 768
    }
    return window.innerWidth < 768
  }
}
